import React from 'react';
import _ from 'lodash';
import { ProseMirror as _prosemirror } from 'prosemirror/edit';
import { menuBar } from 'prosemirror/menu';
import { Node } from 'prosemirror/model';
import { buildKeymap } from 'prosemirror/example-setup/keymap';

import MENU_CONFIGS from './menu';
import schema from './schema';
import migrateNode from './migrate';

import './ProseMirror.scss';

function emptyDoc(text) {
  const textBlock = text ? { content: [{ type: 'text', text }] } : '';
  return { type: 'doc', content: [{ type: 'paragraph', ...textBlock }] };
}

function prepareDoc(value) {
  if (typeof value === 'string' && this) {
    this.pm.setContent(value, 'html');
  }
  const json = _.isObject(value) ? migrateNode(value) : emptyDoc(value);
  return Node.fromJSON(schema, json);
}

class ProseMirror extends React.Component {
  static displayName = 'ProseMirror';
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
    };
    this.pmDOM = null;
    this.pm = null;
    this.trackingInterval = null;
  }

  componentWillMount() {
    const { value } = this.props.valueLink;

    const pm = new _prosemirror({
      doc: prepareDoc(value),
      docFormat: 'json',
      autoInput: true,
      itemEmbeds: true,
      schema,
      plugins: [
        menuBar.config({
          content: MENU_CONFIGS[this.props.menu || 'default'],
        }),
      ],
      ...this.props.options,
    });

    pm.addKeymap(buildKeymap(schema));

    this.pm = pm;
    window.pm = pm;

    pm.requestNodeModal = (component, props) => {
      this.setState({
        modal: {
          component,
          props: {
            ...props,
            close: () => this.setState({ modal: null }),
          },
        },
      });
    };
  }

  componentDidMount() {
    const self = this;
    this.pmDOM.appendChild(this.pm.wrapper);
    this._updatePMContent = _.throttle(() => {
      self._lastValue = this.pm.doc.toJSON();
      this.props.valueLink.requestChange(self._lastValue);
    }, 250);

    this.pm.on.change.add(this._updatePMContent);
  }

  shouldComponentUpdate(nextProps) {
    return !_.isEqual(nextProps.valueLink.value, this.props.valueLink.value);
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props.valueLink;
    const prevValue = prevProps.valueLink.value;

    if (value !== prevValue) {
      clearTimeout(this.trackingInterval);
      this.trackingInterval = setTimeout(
        this.props.onContentUpdate,
        TRACKING_FRQ_TIMEOUT,
        value,
      );

      if (value !== this._lastValue) {
        this.pm.setDoc(prepareDoc(value));

        // This is important for refreshing content during less
        // orthodox changes, like moving items in ListManager.
        if (this._lastValue !== undefined) {
          this._updatePMContent();
        }
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.trackingInterval);
    this.pm.on.change.remove(this._updatePMContent);
  }

  render() {
    const { modal } = this.state;
    return (
      <div className="ProseMirror-component">
        {modal && (
          <div className="modal">
            <modal.component {...modal.props} />
          </div>
        )}
        <div
          ref={(node) => {
            this.pmDOM = node;
          }}
        />
      </div>
    );
  }
}

export default ProseMirror;

export function docIsEmpty(doc) {
  // This is a bit of an extrapolated check to see
  // if the doc object is empty.
  if (doc.content && doc.content.length === 1) {
    const keys = _.keys(doc.content[0]);
    return !_.includes(keys, 'content');
  }
  return false;
}
